// Cache for dynamically loaded topic images
let cachedImageContext: any = null;

/**
 * Dynamically loads ALL jpg/jpeg/png files from the topic_images folder
 * Uses require.context to scan the folder at build time and returns actual module URLs
 */
const loadTopicImagesContext = (): any => {
  if (cachedImageContext) {
    return cachedImageContext;
  }

  try {
    // Use require.context to get ALL image files from the topic_images folder
    cachedImageContext = require.context('../assets/images/topic_images', false, /\.(jpg|jpeg|png)$/i);
    return cachedImageContext;
  } catch (error) {
    console.warn('Failed to dynamically load topic images context');
    throw error;
  }
};

/**
 * Returns a random topic image from ANY jpg/jpeg/png file in the topic_images folder
 * Automatically includes any new images you add to the folder - no code changes needed!
 * @deprecated Backend topic image loading is deprecated, use this for local random selection  
 */
export const getRandomTopicImage = (): string => {
  try {
    const context = loadTopicImagesContext();
    const keys = context.keys();
    if (keys.length === 0) {
      console.warn('No topic images found');
      return '';
    }
    
    const randomIndex = Math.floor(Math.random() * keys.length);
    const randomKey = keys[randomIndex];
    // context(key) returns the actual imported module URL
    return context(randomKey).default || context(randomKey);
  } catch (error) {
    console.warn('Failed to load random topic image, using fallback');
    // Return empty string to trigger fallback icon
    return '';
  }
};

/**
 * @deprecated Use getRandomTopicImage() instead. Backend topic image functionality is deprecated.
 */
export const getTopicImageUrl = (topicName: string): string => {
  return getRandomTopicImage();
};